import { Modal } from "react-bootstrap";
import './Popup.css'

const Popup = ({ show, handleClose, children,size }) => {
  return (
    <Modal show={show} size onHide={handleClose} centered className="rounded-3" {...(size ? { size } : {})} >
      <Modal.Body className=" popup-body " >
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default Popup;